import Menus from './MenusContainer'
import WhiteLabelMenus from './WhiteLabelMenusContainer'

export { WhiteLabelMenus }
export default Menus
